import {
  Component,
  Input,
  Type,
  AfterViewInit,
  OnDestroy,
  OnChanges,
  HostBinding,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ElementRef,
  ComponentFactoryResolver,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';

import { DynamicComponentLoader } from '../../base/dynamic-component-loader.service';

interface NavItem {
  title: string;
  name: string;
  active: boolean;
  component: Type<any>;
  data?: any;
}


@Component({
  moduleId: module.id,
  selector: 'dynamic-navs',
  templateUrl: 'dynamic-navs.component.html',
  styleUrls: ['dynamic-navs.component.scss'],
  providers: [DynamicComponentLoader]
})
export class DynamicNavsComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() navs: NavItem[] = [];

  @Input() isVersion2: boolean = false;

  @Output() changeNav: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class.dynamic-navs') dynamicNavs: boolean = true;

  @ViewChild('navContainer', { read: ViewContainerRef, static: false }) navContainer: ViewContainerRef | void;

  componentRef: ComponentRef<any>;
  activeNav: NavItem;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private dynamicComponentLoader: DynamicComponentLoader
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (_.get(changes, 'navs.currentValue')) {
      if (!changes.navs.currentValue.length) {
        this.resetActiveNav();
      }
    }
  }

  ngAfterViewInit() {
    const activeNav = _.find(this.navs, ['active', true]);
    if (!activeNav) { return; }
    this._loadComponent(activeNav);
  }

  ngOnDestroy() {
    this.resetActiveNav();
  }

  onSelectNav($event: any) {
    this.selectNav($event.name);
  }

  public selectNav(name: string) {
    // to be sure only one nav is active
    _.each((this.navs), (nav: NavItem) => {
      if (nav.name !== name) {
        nav.active = false;
      }
    });
    // don't load already loaded nav
    if (_.get(this.activeNav, 'name') === name) {
      this.activeNav.active = true;
      return;
    }
    const selected = _.find(this.navs, ['name', name]);
    if (!selected) { return; }
    selected.active = true;
    this._loadComponent(selected);
    _.defer(() => {
      this.changeNav.emit({nav: selected, componentRef: this.componentRef});
    });
  }

  public resetActiveNav(): void {
    this.dynamicComponentLoader.destroy();
    this.componentRef = null;
    this.activeNav = null;
  }

  private _loadComponent(activeNav: NavItem): void {
    if (!activeNav) { throw new Error('Active Nav Item is not specified!'); }
    if (!activeNav.component) { throw new Error('Component is not found!'); }
    this.componentRef = this.dynamicComponentLoader.load(
      activeNav.component, this.navContainer, activeNav.data
    );
    this.activeNav = activeNav;
  }
}
